(function() {
  'use strict';
  
  angular.module('ringbaPortal').directive('occupyScrollSpace', occupyScrollSpace);
  
  function occupyScrollSpace(
    
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      scope: {
        loadMoreLogs: '&',
        logs: '<',
        shouldCheckForMoreLogs: '<'
      },
      controller: OccupyScrollSpaceController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function OccupyScrollSpaceController(
      $timeout
    ) {
      'ngInject';

      const vm = this;

      vm.$onChanges = onChanges;

      function onChanges(changesObj) {
        if (changesObj.logs && vm.logs && vm.shouldCheckForMoreLogs) {
          $timeout(function () {
            if ($('.changelogs') && !$('.changelogs').hasScrollBar()) {
              vm.loadMoreLogs();
            }
          });
          
        }
      }
    }

    
  }
})();